import { render } from "./Slideshow.vue?vue&type=template&id=75e52908&scoped=true"
const script = {}

import "./Slideshow.vue?vue&type=style&index=0&id=75e52908&scoped=true&lang=css"

import exportComponent from "C:\\Users\\carlc\\portfolio\\portfolio-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e52908"]])

export default __exports__